import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

import { AssetUtils } from '®shared/asset-utils';
import {
  OnlineResource,
  OnlineResourceGoogleBooksType,
  OnlineResourceUrl,
} from '®shared/bibliographic-resource';
import { PlayerResourceUtils } from '®shared/player-resource';
import { UriService } from '®shared/url-utils';

import {
  ExternalLinkClickEvent,
  LinkPositionOnPage,
  getOnlineResourceEventProperties,
} from '../events';

/**
 * Component offering an online resource button, to present the definitive
 * online offering for a given list-item with resource.
 */
@Component({
  selector: 'rl-online-resource-button',
  templateUrl: './online-resource-button.component.html',
})
export class OnlineResourceButtonComponent implements OnChanges {
  OnlineResourceGoogleBooksType = OnlineResourceGoogleBooksType;

  @Input() itemElementId: string;
  @Input() onlineResource: OnlineResource;
  @Output() onlineResourceClick = new EventEmitter<ExternalLinkClickEvent>();

  absoluteUrl: string;

  isPlayerResource: boolean;

  constructor(private uriService: UriService) {}

  ngOnChanges(_changes?: SimpleChanges) {
    const onlineResourceUrl = this.onlineResource as OnlineResourceUrl;

    if (onlineResourceUrl && onlineResourceUrl.external_url) {
      const { external_url, original_url } = onlineResourceUrl;
      this.absoluteUrl =
        this.uriService.getExternalLinkRelativeToBaseUri(external_url);
      this.isPlayerResource = PlayerResourceUtils.isPlayerUrl(original_url);
    }
  }

  get googleBooksPlaceholder(): string {
    return AssetUtils.getAssetBaseUri()
      .segment('shipshape-assets/gbs_preview_button1.gif')
      .toString();
  }

  onlineResourceClicked(): void {
    this.onlineResourceClick.emit(
      getOnlineResourceEventProperties(
        this.onlineResource,
        this.isPlayerResource,
        LinkPositionOnPage.VIEW_ONLINE_BUTTON,
      ),
    );
  }
}
